import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function initFooter() {

    const siteFooter = document.querySelector('.site-footer')
	
    if (!siteFooter) return
	
    const siteFooterContainer = siteFooter.querySelector('.site-footer__container')
	if (!siteFooterContainer) return

	siteFooter.footerTween?.kill()
	
    siteFooter.footerTween = gsap.from(siteFooterContainer, {
		yPercent: -20,
		ease: 'none',
		scrollTrigger: {
			trigger: siteFooter,
			start: "top bottom",
			end: () => {
					const h = siteFooter.offsetHeight
					const vh = window.innerHeight

				return h < vh ? "bottom bottom" : "top top"
			},
			scrub: true,
		},
    })

}
